import axios from "utils/axios";
import { stringify } from "query-string";

export const getReimbursementCategories = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/reimbursementCategories/pagination?${query}`);
};

export const getReimbursementCategory = (id) => {
  return axios.get(`/hr/reimbursementCategories/${id}`);
};

export const addReimbursementCategory = (data) => {
  return axios.post("/hr/reimbursementCategories", data);
};

export const editReimbursementCategory = ({ id, ...data }) => {
  return axios.put(`/hr/reimbursementCategories/${id}`, data);
};

export const deleteReimbursementCategory = (id) => {
  return axios.delete(`/hr/reimbursementCategories/${id}`);
};
